<ng-container *ngIf="rowData">
  <!-- Desktop View -->
  <tr
    class="dynamic-table__tr"
    [class.dynamic-table__tr--has-borders]="!rowData.isExpanded"
    *ngIf="(isCardView$ | async) === false"
  >
    <!-- <td class="dynamic-table__td">
      <ng-container [ngTemplateOutlet]="checkBoxTemplate"> </ng-container>
    </td> -->
    <td class="dynamic-table__td">
      {{ rowData.NAME }}
    </td>
    <td class="dynamic-table__td">{{ rowData.documentTypes }}</td>
    <td class="dynamic-table__td subscriptions-products-row-table__expand-td">
      <ng-container [ngTemplateOutlet]="toggleButtonTemplate"> </ng-container>
    </td>
  </tr>
  <tr
    *ngIf="rowData.isExpanded && (isCardView$ | async) === false"
    class="dynamic-table__tr dynamic-table__tr--has-borders"
  >
    <td colspan="3">
      <eds-panel [hasPadding]="true" theme="grey">
        <ng-container [ngTemplateOutlet]="addtionalInfoTemplate">
        </ng-container>
      </eds-panel>
    </td>
  </tr>
  <!-- Mobile View -->
  <eds-panel
    *ngIf="(isCardView$ | async) === true"
    edsSpacing="lg"
    [hasBorders]="true"
    [hasBorderRadius]="false"
    [hasPadding]="true"
  >
    <div edsSpacing="md" class="cards-mobile__title">
      <!-- <ng-container [ngTemplateOutlet]="checkBoxTemplate"> </ng-container> -->
      <eds-title [level]="3" size="h6" [isLight]="true">
        {{ rowData.NAME }}
      </eds-title>
    </div>
    <div edsSpacing="md">
      <ng-container *ngFor="let primaryData of mobilePrimaryData">
        <eds-info-item [info]="primaryData" edsSpacing="sm"></eds-info-item>
      </ng-container>
    </div>
    <button
      edsButton="icon-only"
      edsSpacing="md"
      *ngIf="rowData.isExpanded"
      (click)="toggleClose()"
    >
      <span class="ft__btn__txt">{{ "subscriptions.close" | translate }}</span>
      <eds-icon type="carrot-up" size="small"></eds-icon>
    </button>
    <button
      edsButton="icon-only"
      *ngIf="!rowData.isExpanded"
      (click)="toggleExpand()"
    >
      <span class="ft__btn__txt">{{
        "subscriptions.view-documents" | translate
      }}</span>
      <eds-icon type="carrot-down" size="small"></eds-icon>
    </button>
    <eds-panel theme="grey" *ngIf="rowData.isExpanded">
      <ng-container [ngTemplateOutlet]="addtionalInfoTemplate"> </ng-container>
    </eds-panel>
  </eds-panel>

  <!-- <ng-template #checkBoxTemplate>
    <eds-checkbox
      class="checkbox-cell-renderer"
      [hideLabel]="true"
      [inline]="true"
      [checked]="rowData?.isChecked"
      (checkedChange)="onToggle($event)"
    ></eds-checkbox>
  </ng-template> -->

  <ng-template #toggleButtonTemplate>
    <button
      edsButton="icon-only"
      *ngIf="rowData.isExpanded"
      (click)="toggleClose()"
      class="subscriptions-products-row-table__expand-btn"
    >
      <span class="ft__btn__txt">{{ "subscriptions.close" | translate }}</span>
      <eds-icon type="carrot-up" size="small"></eds-icon>
    </button>
    <button
      edsButton="icon-only"
      *ngIf="!rowData.isExpanded"
      (click)="toggleExpand()"
      class="subscriptions-products-row-table__expand-btn"
    >
      <span class="ft__btn__txt">{{
        "subscriptions.view-documents" | translate
      }}</span>
      <eds-icon type="carrot-down" size="small"></eds-icon>
    </button>
  </ng-template>

  <ng-template #addtionalInfoTemplate>
    <div
      [class.subscriptions-products-row-card]="(isCardView$ | async) === true"
      [class.subscriptions-products-row--disabled]="isSavingDocuments"
      *ngIf="allDocumentsData?.length && !isLoading"
    >
      <div
        [edsSubGrid]="(isCardView$ | async) === true ? 'layout-0' : 'layout-1'"
      >
        <div *ngIf="fundLiteratureDocuments?.length">
          <eds-title
            edsSpacing="md"
            [level]="3"
            size="h6"
            [isLight]="true"
            [title]="'subscriptions.fund-literature' | translate"
          >
          </eds-title>
          <div
            [style.display]="'flex'"
            *ngFor="let data of fundLiteratureDocuments"
          >
            <eds-checkbox
              class="checkbox-cell-renderer"
              [hideLabel]="true"
              [inline]="true"
              [checked]="data?.isChecked"
              (checkedChange)="onSelectionChanged($event, data)"
            ></eds-checkbox>
            <p>{{ data.documentTitle }}</p>
          </div>
        </div>
        <div *ngIf="regulatoryDocuments?.length">
          <eds-title
            edsSpacing="md"
            [level]="3"
            size="h6"
            [isLight]="true"
            [title]="'subscriptions.regulatory-documents' | translate"
          >
          </eds-title>
          <div
            [style.display]="'flex'"
            *ngFor="let data of regulatoryDocuments"
          >
            <eds-checkbox
              class="checkbox-cell-renderer"
              [hideLabel]="true"
              [inline]="true"
              [checked]="data?.isChecked"
              (checkedChange)="onSelectionChanged($event, data)"
            ></eds-checkbox>
            <p>{{ data.documentTitle }}</p>
          </div>
        </div>
      </div>
      <div edsFlexbox flexWrap="wrap" justifyContent="flex-end">
        <button
          *ngIf="!isSavingDocuments"
          edsButton="primary"
          (click)="subscribeAllDocuments()"
          [disabled]="isAllDocumentsSelected"
        >
          <span class="ft__btn__txt">{{
            "subscriptions.subscribe-to-all" | translate
          }}</span>
        </button>
        <button
          *ngIf="!isSavingDocuments"
          edsButton="primary"
          (click)="updateSubscription()"
          [disabled]="selectedDocuments?.length === 0"
        >
          <span class="ft__btn__txt">{{
            "subscriptions.update-subscription" | translate
          }}</span>
        </button>
        <!-- Spinner -->
        <span
          class="subscriptions-products-row-card__loader"
          [class.subscriptions-products-row-card__loader--disabled]="
            !isSavingDocuments
          "
        >
          <ngx-spinner
            name="documentSavingSpinner"
            bdColor="rgba(0,0,0,0)"
            size="small"
            color="#000"
            type="line-scale-party"
            [fullScreen]="false"
          >
          </ngx-spinner>
        </span>
      </div>
    </div>
    <div class="subscriptions-products-row-table__loader" *ngIf="isLoading">
      <eds-progress-spinner
        [isHide]="false"
        [ifLoadingText]="true"
        size="medium"
        [loadingText]="'subscriptions.fetching-fund-documents' | translate"
        spinnerName="FundDocumentsLoadingSpinner"
      ></eds-progress-spinner>
    </div>
    <div *ngIf="allDocumentsData?.length === 0 && !isLoading">
      <span>{{ "subscriptions.no-data" | translate }}</span>
    </div>
  </ng-template>
</ng-container>
